var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector123X2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.857,0C18.311,0 13.95,1.686 10.735,4.686C7.52,7.687 5.714,11.757 5.714,16L0,16L7.41,22.916L7.543,23.164L15.238,16L9.524,16C9.524,9.12 15.486,3.556 22.857,3.556C30.229,3.556 36.19,9.12 36.19,16C36.19,22.88 30.229,28.444 22.857,28.444C19.181,28.444 15.848,27.04 13.448,24.782L10.743,27.307C12.33,28.797 14.218,29.979 16.297,30.784C18.376,31.59 20.606,32.003 22.857,32C27.404,32 31.764,30.314 34.979,27.314C38.194,24.313 40,20.243 40,16C40,11.757 38.194,7.687 34.979,4.686C31.764,1.686 27.404,0 22.857,0ZM20.952,8.889L20.952,17.778L29.048,22.258L30.514,19.982L23.81,16.267L23.81,8.889L20.952,8.889Z",
    fill: "#2D2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector123X2);
export default __webpack_public_path__ + "static/media/vector_123_x2.b3fb392120e0d87b102fdc183764e2df.svg";
export { ForwardRef as ReactComponent };